import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LeadDetailRoutingModule } from './lead-detail-routing.module';
import { LeadDetailComponent } from './lead-detail.component';
import { MatIconModule } from '@angular/material/icon';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';;
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';


import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CalsoftpipeModule } from 'src/app/shared/utils/calsoftpipe/calsoftpipe.module';
import { ActivityModule } from '../activity/activity.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SimpleDynamicComponentModule } from 'src/app/shared/simple-form/simple-dynamic-component.module';
import { CommonImagesModule } from '../../common-images/common-images.module';
import { VideosModule } from 'src/app/shared/videos/videos.module';
import { AudiosModule } from 'src/app/shared/audios/audios.module';
import { IconModule } from '@visurel/iconify-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { LoaderModule } from '../../loader/loader.module';
import { EmailPopupComponentComponent } from './email-popup-component/email-popup-component.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { WhatsappChatModule } from '../../whatsappChatModule/whatsapp-chat/whatsapp-chat.module';
import { GoogleCalendarServiceAccountModule } from '../../google-calendar-service-account/google-calendar-service-account.module';
import { DealsModule } from '../deals/deals.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { ImagesModule } from '../../gold/images/images.module';
import { UploadPdfModule } from 'src/app/shared/upload-pdf/upload-pdf.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { AccountCompaniesTableComponent } from './account-companies-table/account-companies-table.component';
import { TemplateConfirmPopupComponent } from './email-popup-component/template-confirm-popup/template-confirm-popup.component';
import { DealTableComponent } from './deal-table/deal-table.component';
import { ProfileEditorDialogComponent } from './profile-editor-dialog/profile-editor-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { LeadsmeetingModule } from '../../companies/leadsmeeting/leadsmeeting.module';
import { ActivityNewModule } from './activity-new/activity-new.module';
import { TaskNewModule } from 'src/app/shared/task-new/task-new.module';
import { FieldEditDialogComponent } from './field-edit-dialog/field-edit-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { DateFormatIssueComponent } from './deal-table/date-format-issue/date-format-issue.component';
import { SendSmsPopupComponent } from './send-sms-popup/send-sms-popup.component';
import { PhoneDialerModule } from '../../phone-dialer/phone-dialer.module';
import { SendEmailTableComponent } from './send-email-table/send-email-table.component';
import { SendAllEmailModule } from '../send-all-email/send-all-email.module';
import { InboundEmailsModule } from '../inbound-emails/inbound-emails.module';
import { ViewsComponent } from './views/views.component';
import { WhatsAppNewClientModule } from '../../whats-app-new-client/whats-app-new-client.module';
import { AccountSequencesTableComponent } from './account-sequences-table/account-sequences-table.component';
import { TaskTableModule } from '../../sequence/task-table/task-table.module';
import { DocEditorModule } from 'src/app/shared/doc-editor/doc-editor.module';
import { ConfirmYesNoDialogComponent } from './confirm-yes-no-dialog/confirm-yes-no-dialog.component';
import { CollaborationModule } from 'src/app/shared/collaboration/collaboration.module';
import { NextBestActionModule } from './next-best-action/next-best-action.module';
import { AddSiteVisitComponent } from '../add-site-visit/add-site-visit.component';
import { DynamicAdditionalDetailsComponent } from '../dynamic-additional-details/dynamic-additional-details.component';
import { LeadRetryHistoryModule } from './lead-retry-history/lead-retry-history.module';

@NgModule({
    declarations: [
        LeadDetailComponent,
        EditprofileComponent,
        EmailPopupComponentComponent,
        AccountCompaniesTableComponent,
        TemplateConfirmPopupComponent,
        DealTableComponent,
        ProfileEditorDialogComponent,
        FieldEditDialogComponent,
        DateFormatIssueComponent,
        SendSmsPopupComponent,
        SendEmailTableComponent,
        ViewsComponent,
        AccountSequencesTableComponent,
        ConfirmYesNoDialogComponent,
        DynamicAdditionalDetailsComponent
    ],
    imports: [
        CommonModule,
        MatTooltipModule,
        LeadDetailRoutingModule,
        CustomFlexLayoutModule,
        WhatsappChatModule,
        MatIconModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatTabsModule,
        MatMenuModule,
        CalsoftpipeModule,
        ActivityModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        NgxMatSelectSearchModule,
        SimpleDynamicComponentModule,
        CommonImagesModule,
        VideosModule,
        AudiosModule,
        IconModule,
        LoaderModule,
        PerfectScrollbarModule,
        GoogleCalendarServiceAccountModule,
        DealsModule,
        MatButtonToggleModule,
        MatChipsModule,
        ImagesModule,
        UploadPdfModule,
        CommonFileUploadModule,
        PipesModule,
        MatCardModule,
        LeadsmeetingModule,
        MatMenuModule,
        ActivityNewModule,
        TaskNewModule,
        MatAutocompleteModule,
        PhoneDialerModule,
        SendAllEmailModule,
        InboundEmailsModule,
        WhatsAppNewClientModule,
        PipesModule,
        TaskTableModule,
        DocEditorModule,
        CollaborationModule,
        NextBestActionModule,
        AddSiteVisitComponent,
        LeadRetryHistoryModule
    ],
    exports: [LeadDetailComponent, AccountCompaniesTableComponent, TemplateConfirmPopupComponent, DealTableComponent]
})
export class LeadDetailModule { }
